export default {
	light: `'apercu-light', sans-serif`,
	regular: `'apercu-regular', sans-serif`,
	medium: `'apercu-medium', sans-serif`,
	bold: `'apercu-bold', sans-serif`,
};
